// It seems theres a pattern of naming types SALES_HOUSEHOLD_[country_code],
// e.g. SALES_HOUSEHOLD_FI. Since it's hard to determine the full list and
// if new records will be added, it makes sense to cover the whole pattern here
import { InvoiceTypeInterface } from 'client/Interfaces/InvoiceTypeInterface'

export const isInvoiceTypeWithMandatoryVatColumn = (type) =>
  !!(type?.type === 'SALES' || type?.type?.startsWith('SALES_HOUSEHOLD_'))

export const shouldHideVatColumn = (type: InvoiceTypeInterface | { type?: any }) =>
  ['SALES_EU_GOODS', 'SALES_NONEU_GOODS'].includes(type?.type)
